import { gsapSingleton, scrollSmootherSingleton, scrollTriggerSingleton } from './gsap';

const gsap = gsapSingleton();
const ScrollSmoother = scrollSmootherSingleton();
const ScrollTrigger = scrollTriggerSingleton();

let smoother = null;

export function initSmoothScroll() {
  if (smoother) return smoother;

  const wrapper = document.getElementById('smooth-wrapper');
  const content = document.getElementById('smooth-content');
  if (!wrapper || !content) return null;

  // Mobile: NIENTE smoother e NIENTE normalizeScroll, scroll nativo puro.
  // Entrambi guidano lo scroll via JS e cambiano il feeling del touch
  // (momentum simulato → percepito come scattoso). ScrollTrigger funziona
  // comunque sullo scroll nativo; per i pin su mobile si usa position:sticky
  // (compositor, zero JS) — vedi IntroTitleSwap.
  // AnchorScroll ha gia' il fallback window.scrollTo quando smoother e' null.
  const isTouch = ('ontouchstart' in window) && window.matchMedia('(max-width: 768px)').matches;
  if (isTouch) {
    return null;
  }

  smoother = ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    smooth: 1.2,
    effects: true,
    normalizeScroll: true,
    smoothTouch: 0.1,
    ignoreMobileResize: true,
  });

  // Deep-link (#hash in URL): con lo smoother attivo lo scroll nativo del
  // browser all'ancora si perde. Dopo il load (layout stabile) scrolliamo
  // noi al target, con offset per l'header fisso.
  const scrollToHash = () => {
    if (!window.location.hash) return;
    let target = null;
    try { target = document.querySelector(window.location.hash); } catch (e) { return; }
    if (!target) return;

    let offset = 0;
    const header = document.getElementById('header');
    if (header) {
      const pos = window.getComputedStyle(header).position;
      if (pos === 'fixed' || pos === 'sticky') offset = header.offsetHeight;
    }
    smoother.scrollTo(target, false, `top ${offset}px`);
  };

  // Refresh dopo caricamento immagini, poi aggancia l'eventuale hash.
  window.addEventListener('load', () => {
    ScrollTrigger.refresh();
    requestAnimationFrame(scrollToHash);
  });

  return smoother;
}

export function getSmoother() {
  return smoother;
}
